import { Button } from "../components/button/Button";
import { ButtonProps } from "../components/button/ButtonProps";
import { DomEvent } from "./DomEvent";
import { EventListener } from "./Event";
import { Table } from "../components/table/Table";
import { TableRow } from "../components/table/TableRow";
import { TableRowDisplayEvent } from "./TableRowDisplayEvent";

export interface TableRowAdditionalToolsDisplayListener extends EventListener<TableRowAdditionalToolsDisplayEvent> {
}

export class TableRowAdditionalToolsDisplayEvent extends TableRowDisplayEvent {
    constructor(component: TableRow, table: Table, domEvent?: DomEvent) {
        super(component, table, domEvent);
    }

    public getAdditionalToolButtons(): Button[] {
        return this.getTableRow()?.additionalToolButtons;
    }

    setAdditionalToolProps(id: string, props: Partial<ButtonProps>) {
        this.getTableRow().setAdditionalToolProps(id, props);
    }
}
